import '../../../styles/index.css'
import './CardProduto.scss';
import Preço from '../../Preços/Preço/Preço';
import Bell from '../../../assets/icons/Bell Icon.svg'
import CustomButton from '../../Buttons/CustomButton/CustomButton';
import { Link } from 'react-router-dom';
import { formataNome } from '../../../utils/nomes.js';

function CardProduto({ imagem, nome, preço, preçoParcelado, qtdOfertas, categoria, id, setPreçoProdutoDesejado, setIdProdutoDesejado }) {

  return (

    <section className='card-produto-container shadow'>

      <div className='informacoes-container'>

        <div className='imagem-card-produto-container'>
          <img className='imagem-card-produto' src={imagem} alt="Produto" data-cy="card-produto-imagem"/>
        </div>

        <div className='descricoesCardProduto'>

          <p className='b2 negrito'>{formataNome(nome, 45)}</p>

          <Preço preço={preço} preçoParcelado={preçoParcelado} />

          <Link to={`/Produto/${categoria}/${id}`} className='link'>
            <p className='verMais' data-cy="card-produto-qtd-ofertas">{
              qtdOfertas > 1 ? `Ver esta e ${qtdOfertas - 1} ofertas` : 'Ver esta oferta'
            }</p>
          </Link>

        </div>

      </div>

      <div className='botoes-container'>

        <div onClick={() => {
          setPreçoProdutoDesejado(preço)
          setIdProdutoDesejado(id)
        }} data-bs-toggle="modal" data-bs-target="#modalNotificar" data-cy="card-produto-botao">
          <CustomButton texto='Criar Alerta' cor='white' tipo='3' icone={Bell}/>
        </div>

        <Link to={`/Produto/${categoria}/${id}`} className='link' data-cy="card-produto-link">
          <CustomButton texto='Comparar preços' cor='#A80A01' tipo='3' />
        </Link>

      </div>


    </section>

  );
}

export default CardProduto;
